/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrderPaymentStatus = 'Approved' | 'Created' | 'Failed' | 'Fulfilled' | 'Released';

export type BagPaymentStateQueryVariables = Exact<{
  orderId: string;
  orderType: string;
}>;

export type BagPaymentStateQuery = {
  readonly orderPaymentState: {
    readonly __typename: 'OrderPaymentState';
    readonly id: string;
    readonly paymentIntentId: string;
    readonly paymentIntentSecret: string;
    readonly status: Types.OrderPaymentStatus;
    readonly error: string | null;
    readonly updatedAt: string;
  } | null;
};

export const BagPaymentStateDocument = gql`
  query BagPaymentState($orderId: String!, $orderType: String!) {
    orderPaymentState(orderId: $orderId, orderType: $orderType) {
      id
      paymentIntentId
      paymentIntentSecret
      status
      error
      updatedAt
      __typename
    }
  }
`;

export function useBagPaymentStateQuery(
  options: Omit<Urql.UseQueryArgs<BagPaymentStateQueryVariables>, 'query'>,
) {
  return Urql.useQuery<BagPaymentStateQuery, BagPaymentStateQueryVariables>({
    query: BagPaymentStateDocument,
    ...options,
  });
}
